import React from 'react';
import { CtaButton } from './CtaButton';
export function PriceSection() {
  return <section className="w-full bg-white py-10 md:py-16 px-6" data-id="element-129">
      <div className="max-w-3xl mx-auto text-center" data-id="element-130">
        <p className="text-xl md:text-2xl mb-8 text-[#1a1a2e] leading-relaxed" data-id="element-131">
          Most parenting consultants charge $150/hour to tell you half of what
          is in this guide.
        </p>

        <div className="mb-8" data-id="element-132">
          <p className="text-lg md:text-xl mb-4 text-[#1a1a2e]" data-id="element-133">
            Regular Price:
          </p>
          <p className="text-3xl md:text-4xl line-through text-gray-500 mb-4" data-id="element-134">
            $27.00
          </p>

          <p className="text-lg md:text-xl mb-4 text-[#1a1a2e] font-semibold" data-id="element-135">
            Today's Peace-at-Home Price:
          </p>
          <p className="text-5xl md:text-6xl font-black text-green-600 mb-8" data-id="element-136">
            $6.37
          </p>
        </div>

        <CtaButton text="Get Peace Tonight for $6.37" data-id="element-137" />
      </div>
    </section>;
}